module.exports = __webpack_public_path__ + "static/media/07.1589baf9.png";